export default "https://c.travel-assets.com/partner-portal/person_pin.62759afd1711.svg";